import { useTheme } from "next-themes"
import { Toaster as Sonner, ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      style={
        {
          "--normal-bg": "rgba(255, 255, 255, 0.1)",
          "--normal-text": "rgba(255, 255, 255, 0.95)",
          "--normal-border": "rgba(255, 255, 255, 0.14)",
        } as React.CSSProperties
      }
      {...props}
    />
  )
}

export { Toaster }
